<template>
  <section class="section section--member section--bg">
    <div class="container">
      <div class="title">
        出勤予定
      </div>
      <p class="notification_text" v-if="upComingLives.length <= 0">現在、出勤予定のキャストはいません。</p>
      <ul class="columns is-multiline is-mobile">
        <LiveListedTile
          v-for="live in upComingLives"
          :key="live.id"
          :tileData="{
            liveId: live.id,
            imageSrc: live.thumbnailURL,
            nickname: live.performerNickname,
            genre: live.categories,
            startAt: live.startAt,
            title: live.title,
            type: 'upComingLive'
          }"
          :onClick="liveTileClicked"
        />
      </ul>
    </div>
  </section>
</template>

<script>
import { auth } from '@/plugins/firebase';
import { mapState } from 'vuex';
import LiveListedTile from '@/components/Molecules/LiveListedTile';
import { analyticsLog } from '@/utils/analytics';

const tilesNumber = 10000;

export default {
  name: 'LiveUpComing',
  components: {
    LiveListedTile
  },
  computed: {
    ...mapState({
      upComingLives: state => state.live.upComingAllLives.slice(0, tilesNumber)
    })
  },
  async created() {
    const that = this;
    auth.onAuthStateChanged(async user => {
      if (!user.emailVerified && !that.$route.path.includes('signup')) {
        that.$router.push('/user/created');
      }
      await this.$store.dispatch('live/loadUpComingAllLives');
    });
    analyticsLog('配信予定【表示時】');
  },
  methods: {
    liveTileClicked(id, type) {
      const path = `/live/streaming/${id}?type=${type}`;
      this.$router.push(path);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/live-upcoming.scss';
</style>
